const Line = () => <div className="h-8 w-full rounded bg-gray-300/80" />;

const SkeletonLoader = () => {
  return (
    <div className="flex w-full animate-pulse flex-col space-y-6">
      <div className="space-y-4">
        <Line />
        <Line />
        <Line />
        <Line />
      </div>
    </div>
  );
};

export default SkeletonLoader;
